import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider, useLang } from "@/lib/i18n";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { BackToTop } from "@/components/BackToTop";
import { ScrollMascot } from "@/components/ScrollMascot";

import Home from "@/pages/Home";

const SkipLink = () => {
  const { t } = useLang();
  return (
    <a href="#main-content" className="skip-link">
      {t.common.skipToContent}
    </a>
  );
};

/**
 * Site en page unique.
 * Les anciennes routes sont conservées en redirection : elles peuvent
 * exister dans des liens partagés ou dans l'index de Google.
 */
function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="relative min-h-screen bg-canvas text-cream">
          <div className="relative z-[2]">
            <SkipLink />
            <Header />
            <main id="main-content" tabIndex={-1}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/methode" element={<Navigate to="/#methode" replace />} />
                <Route path="/ia" element={<Navigate to="/#studio" replace />} />
                <Route path="/etudes-de-cas" element={<Navigate to="/#cywiz" replace />} />
                <Route path="/a-propos" element={<Navigate to="/#studio" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
            <ScrollMascot />
            <BackToTop />
          </div>
          <Toaster position="bottom-right" theme="dark" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
